(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atc-button"] && !Shopify.designMode) return;
  try {
    const ADD_TO_CART_BUTTON_SELECTOR = '.add-to-cart-button';

  document.addEventListener('DOMContentLoaded', function() {
    const forms = document.querySelectorAll(ADD_TO_CART_BUTTON_SELECTOR);
    forms.forEach((form) => form && manageATCForm(form));
  });

  function manageATCForm(form) {
    form.addEventListener('submit', function(event) {
      setLoading(form);
      event.preventDefault();
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      }).then((response) => response.json()).then((data) => {

// console.log('Product added to cart:', data);
        const event = new CustomEvent('cart:refresh', {bubbles: true});
        document.documentElement.dispatchEvent(event);

        const openCart = new CustomEvent('cart:open', {bubbles: true});
        document.documentElement.dispatchEvent(openCart)

        setSuccess(form);
      }).catch((error) => {
        console.error('Error adding product to cart:', error);
        setError(form);
      });
    });
  }

  function setLoading(form) {
    const button = form.querySelector('button[type="submit"]');
    button.classList.add('loading');
    const spinnerCheckmarkContainer = document.createElement('div');
    spinnerCheckmarkContainer.classList.add('spinner-animation');
    button.classList.add('loading');
    spinnerCheckmarkContainer.innerHTML = `
    <svg class="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
      <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke="#ffffff" stroke-dasharray="100" />
    </svg>
    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <path fill="none" stroke="#ffffff" stroke-width="5" d="M14 27l7 7 16-16"/>
    </svg>
  `;
    button.appendChild(spinnerCheckmarkContainer);

// disable button
    button.disabled = true;
  }

  function setSuccess(form) {
    const button = form.querySelector('button[type="submit"]');
    button.classList.remove('loading');
    button.classList.add('success');
    setTimeout(() => {
      removeATCAnimation(form);
    }, 1000);
  }

  function setError(form) {
    const button = form.querySelector('button[type="submit"]');
    button.classList.remove('loading');
    button.classList.add('error');
    setTimeout(() => {
      removeATCAnimation(form);
    }, 1000);
  }

  function removeATCAnimation(form) {
    const button = form.querySelector('button[type="submit"]');
    button.classList.remove('loading');
    button.classList.remove('error');
    button.classList.remove('success');
    const spinnerCheckmarkContainer = button.querySelector('.spinner-animation');
    spinnerCheckmarkContainer.remove();
    button.disabled = false;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["read-more"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.collapsible-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', ! expanded);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
